import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { cloneDeep, isNil } from "lodash-es"
import * as API from "services/api"
import { errorToast } from "shared/toast"

const SLICE_NAME = "formSubmissionResolution"

const INITIAL_STATE = {
  loading: false,
  resolution: null,
}

// A successful response indicates that the form submission was found
// and the user has access to the form submission.  If the form submission
// has a resolution, the API will return the resolution; otherwise,
// the API will return a no content response.
// See app/controllers/client_organizations/api/v1/resolutions_controller.rb
export const initialize = createAsyncThunk(
  `${SLICE_NAME}/initialize`,
  async ({ formSubmissionSlug }) => {
    const response = await API.formSubmissionResolution({ formSubmissionSlug })

    if (response.ok) {
      const resolution = !response.data ? null : response.data

      return (
        { resolution }
      )
    }

    throw new Error("Something went wrong. Unable to load resolution.")
  },
)

export const formSubmissionResolutionSlice = createSlice({
  name: SLICE_NAME,
  initialState: cloneDeep(INITIAL_STATE),
  reducers: {
    removeResolution: (state) => {
      state.resolution = null
    },
    resetData: (state) => {
      Object.assign(state, cloneDeep(INITIAL_STATE))
    },
    setResolution: (state, action) => {
      const { resolution } = action.payload

      state.resolution = resolution
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(initialize.pending, (state) => {
        state.loading = true
      })
      .addCase(initialize.fulfilled, (state, action) => {
        const { resolution } = action.payload

        state.resolution = resolution
        state.loading = false
      })
      .addCase(initialize.rejected, (state, action) => {
        errorToast(action.error.message)
        state.loading = false
      })
  },
})

export const {
  removeResolution,
  resetData: resetResolutionData,
  setResolution,
} = formSubmissionResolutionSlice.actions

export const loading = (state) => state[SLICE_NAME].loading

export const resolutionSet = (state) => !isNil(state[SLICE_NAME].resolution)

export const resolutionText = (state) => state[SLICE_NAME].resolution?.text || null

export default formSubmissionResolutionSlice.reducer
